import React, { useEffect, useState } from 'react'

const ROUNDS = [
  'Dog',
  'Africa',
  'British Isles',
  'Fish',
  'Empire state building',
  'Plane',
  'Car',
  'Boat',
  'Lorry',
  'Italy',
  'Australia',
  'Houses of Parliament',
  'Fork',
  'Church',
  'Mug',
  'Star',
  'House'
]

const Start = () => {
  const [timeLeft, setTimeLeft] = useState(5)
  const [initialCountdown, setInitialCountdown] = useState(true)
  const [guessedIndex, setGuessedIndex] = useState([])
  const [objectToPoppodominate, setObjectToPoppodominate] = useState(null)
  const [countdownComplete, setCountdownComplete] = useState(false)
  const [finished, setFinished] = useState(false)
  const [paused, setPaused] = useState(false)

  useEffect(() => {
    if (timeLeft === 0) setTimeLeft(null)

    if (!timeLeft && guessedIndex.length > 0) {
      setPaused(true)
    }

    if (!timeLeft) {
      setInitialCountdown(false)
      setCountdownComplete(true)
      return
    }

    if (paused) return

    const intervalId = setInterval(() => setTimeLeft(timeLeft - 1), 1000)

    return () => clearInterval(intervalId)
  }, [timeLeft, paused, guessedIndex])

  useEffect(() => {
    if (countdownComplete && !paused) {
      setCountdownComplete(false)
      let guessIndex = Math.floor(Math.random() * ROUNDS.length)
      const guessesOutstanding = guessedIndex.length < ROUNDS.length
      while (guessedIndex.includes(guessIndex) && guessesOutstanding) {
        guessIndex = Math.floor(Math.random() * ROUNDS.length)
      }
      if (!guessesOutstanding) {
        setFinished(true)
        return
      }
      setGuessedIndex([ ...guessedIndex, guessIndex])
      setObjectToPoppodominate(ROUNDS[guessIndex])
      setTimeLeft(45)
      setPaused(false)
    }
  }, [setCountdownComplete, setTimeLeft, countdownComplete, guessedIndex, paused])

  return (
    <div className="min-h-screen bg-gray-100 py-6 flex flex-col justify-center sm:py-12">
      <div className="relative py-3 sm:max-w-xl mx-auto">
        <div className="absolute inset-0 bg-gradient-to-r from-poppared to-poppablack shadow-lg transform -skew-y-6 sm:skew-y-0 sm:-rotate-6 rounded-3xl"></div>
          <div className="relative px-4 py-10 bg-white shadow-lg rounded-3xl sm:p-20">
            <div className="max-w-md mx-auto">
              <div>
                <img src="/poppadomination2.png" alt='poppadominaton logo' />
              </div>
              <div>
                {initialCountdown && (
                  <div className="p-9 text-center animate-pulse">
                    <div className='text-5xl'>{timeLeft}</div>
                  </div>
                )}
                {(!initialCountdown && !finished) && (
                  <div className="divide-y divide-gray-200 text-center">
                    <div className="text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                      <p>Round {guessedIndex.length}</p>
                      <div className="w-full">
                        <button className='bg-poppadom text-poppablack p-6 rounded-lg'><strong>{objectToPoppodominate}</strong></button>
                      </div>
                      {!paused && (
                        <p>Time up in: {timeLeft} seconds</p>
                      )}
                    </div>
                  </div>
                )}
                {paused && (
                  <div className="p-9 text-center">
                    <button className='bg-poppared text-white p-6 rounded-lg' onClick={(e) => setPaused(false)}><strong>Click to continue</strong></button>
                  </div>
                )}
                {finished && (
                  <div className="p-9 text-center">
                    <div className='text-5xl'>Thanks for playing!</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default Start
